// removed by extract-text-webpack-plugin
module.exports = {"attachmentList":"attachmentList___1rDVm","attachmentListItem":"attachmentListItem___1QY1E","attachmentListItem--link":"attachmentListItem--link___3afY3","attachmentButton":"attachmentButton___3hl9I","attachmentButton--link":"attachmentButton--link___LEGMk","attachmentName":"attachmentName___e9e2u","attachmentRemove":"attachmentRemove___1Mt1d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Comments/CommentItemAttachments.module.scss
// module id = 2321
// module chunks = 0